import React, { Component } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { Segment, SemanticCOLORS, Statistic, List } from "semantic-ui-react";
import { StatisticSizeProp } from "semantic-ui-react/dist/commonjs/views/Statistic/Statistic";
import { Text } from "..";
import { CurrenecyText } from "../text";

interface ISummaryCardType3 extends WithTranslation {
  label: string;
  value?: number;
  value1?: number;
  value2?: number;
  value3?: number;
  unit: string;
  size?: StatisticSizeProp;
  color?: SemanticCOLORS;
  labels?: string[];
}

class SummaryCardType3 extends Component<ISummaryCardType3> {
  public render() {
    const { label, value, unit, size, color } = this.props;
    return (
      <Segment style={styles.segmentStyle}>
        <Statistic color={color} size={size || "tiny"}>
          <Statistic.Label>
            <Text size="medium">{label}</Text>
          </Statistic.Label>
          {value ? (
            <React.Fragment>
              <Statistic.Value>
                <CurrenecyText pureValue size={"big"}>
                  {value || 0}
                </CurrenecyText>
              </Statistic.Value>
              <Statistic.Label>
                <Text size="medium">{unit}</Text>
              </Statistic.Label>
            </React.Fragment>
          ) : null}
        </Statistic>
        {this.renderExtraStatistic()}
      </Segment>
    );
  }
  renderExtraStatistic = () => {
    const { color, size, unit, value1, value2, value3, labels } = this.props;
    if (value1 || value2 || value3) {
      return (
        <div>
          {[value1, value2, value3].map((v, index) => {
            if (v) {
              return (
                <div className="ui grid padded">
                  <Text className="left floated ten wide column left aligned">
                    {labels ? labels[index] : ""}
                  </Text>
                  <div className="large label label-text right floated six wide column right aligned">
                    <CurrenecyText pureValue size={"medium"} unit={unit}>
                      {v || 0}
                    </CurrenecyText>
                    <Text size="medium">{unit}</Text>
                  </div>
                </div>
              );
            }
          })}
        </div>
      );
    } else {
      return null;
    }
  };
}

const styles = {
  segmentStyle: {
    textAlign: "center"
  }
};

export default withTranslation()(SummaryCardType3);
